import axios, { AxiosResponse } from 'axios';
import { DEFAULT_URL } from '../constants';

// Define interfaces for API responses and requests (optional)
interface ApiResponse {}

interface ApiRequestData {
  // Define your request properties here
}

const apiService = {
  async get(request: any = null, endpoint: string): Promise<any> {
    try {
      const response: AxiosResponse<any> = await axios.get(
        `${DEFAULT_URL}${endpoint}`,
        { params: request },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async post(endpoint: string, data: ApiRequestData): Promise<ApiResponse> {
    try {
      const response: AxiosResponse<ApiResponse> = await axios.post(
        `${DEFAULT_URL}${endpoint}`,
        data,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default apiService;
